import React from "react";
import { useNavigate } from "react-router-dom";
// import useEmblaCarousel from "embla-carousel-react";

const { useState, useEffect, useCallback } = React;
const { ChevronLeft, ChevronRight, ArrowRight } = {
  ChevronLeft: () => <div>‹</div>,
  ChevronRight: () => <div>›</div>,
  ArrowRight: () => <div>→</div>,
};

export const Carousel = () => {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  // https://res.cloudinary.com/dmr9qmows/image/upload/v1763243606/wedding_couple_wu3fen.jpg

  const portfolioImages = [
    {
      src: "https://res.cloudinary.com/shaszstudios-photography/image/upload/v1763247441/weding_couple_hands_mezizf.jpg",
      category: "WEDDINGS",
      title: "Together Forever",
      description: "An intimate celebration of love",
    },
    {
      src: "https://res.cloudinary.com/shaszstudios-photography/image/upload/v1763243647/couple_in_ams_4_uhr4bs.jpg",
      category: "LIFESTYLE",
      title: "Everyday Moments",
      description: "Capturing authentic moments in the city",
    },
    {
      src: "https://res.cloudinary.com/shaszstudios-photography/image/upload/v1763243689/maternity_zanseschans_flying_dress_2_mzrzhw.jpg",
      category: "MATERNITY",
      title: "Expecting Joy",
      description: "The beauty of new beginnings",
    },
    {
      src: "https://res.cloudinary.com/shaszstudios-photography/image/upload/v1762207943/DSC06493_ap2njh.jpg",
      category: "FAMILY",
      title: "Family Memories",
      description: "Timeless family memories",
    },
    {
      src: "https://res.cloudinary.com/shaszstudios-photography/image/upload/v1763247853/newborn_innocence_glhexu.jpg",
      category: "NEWBORN",
      title: "The Little One",
      description: "Pure innocence captured",
    },
  ];

  const nextSlide = useCallback(() => {
    setCurrentIndex((prev) => (prev + 1) % portfolioImages.length);
  }, [portfolioImages.length]);

  const prevSlide = useCallback(() => {
    setCurrentIndex(
      (prev) => (prev - 1 + portfolioImages.length) % portfolioImages.length
    );
  }, [portfolioImages.length]);

  const goToSlide = useCallback((index) => {
    setCurrentIndex(index);
  }, []);

  // Auto-play functionality
  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(nextSlide, 5000);
    return () => clearInterval(interval);
  }, [isAutoPlaying, nextSlide]);

  const handleMouseEnter = () => setIsAutoPlaying(false);
  const handleMouseLeave = () => setIsAutoPlaying(true);

  return (
    <section id="portfolio" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-light text-gray-800 mb-4 tracking-wide">
            FEATURED <span className="italic text-[#548e9b]">work</span>
          </h2>
          <div className="w-16 h-px bg-[#548e9b] mx-auto mb-8"></div>
          <p className="text-gray-600 max-w-2xl mx-auto font-light leading-relaxed">
            A curated selection of recent photography sessions, showcasing the
            beauty and emotion of life's precious moments
          </p>
        </div>

        {/* Main Carousel */}
        <div
          className="relative max-w-5xl mx-auto mb-12"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {/* Image Container */}
          <div className="relative aspect-[3/2] overflow-hidden rounded-lg shadow-2xl">
            {portfolioImages.map((image, index) => (
              <div
                key={index}
                className={`absolute inset-0 transition-all duration-1000 ease-in-out ${
                  index === currentIndex
                    ? "opacity-100 scale-100"
                    : "opacity-0 scale-105"
                }`}
              >
                <img
                  src={image.src}
                  alt={image.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>

                {/* Content Overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-8 text-white">
                  <div className="max-w-md">
                    <p className="text-[10px] md:text-xs tracking-widest mb-1 md:mb-2 text-[#548e9b] font-light uppercase">
                      {image.category}
                    </p>
                    <h3 className="text-lg md:text-3xl font-light mb-1 md:mb-2 tracking-wide">
                      {image.title}
                    </h3>
                    <p className="text-xs md:text-sm opacity-90 font-light leading-relaxed">
                      {image.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={prevSlide}
            className="absolute left-4 top-1/2 -translate-y-1/2 w-8 h-8 md:w-12 md:h-12 bg-white/10 backdrop-blur-md border border-white/20 rounded-full flex items-center justify-center text-white hover:bg-white/20 transition-all duration-300 group"
          >
            <ChevronLeft className="group-hover:-translate-x-0.5 transition-transform" />
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-4 top-1/2 -translate-y-1/2 w-8 h-8 md:w-12 md:h-12 bg-white/10 backdrop-blur-md border border-white/20 rounded-full flex items-center justify-center text-white hover:bg-white/20 transition-all duration-300 group"
          >
            <ChevronRight className="group-hover:translate-x-0.5 transition-transform" />
          </button>
        </div>

        {/* Elegant Dots Navigation */}
        <div className="flex justify-center space-x-3 mb-12">
          {portfolioImages.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`transition-all duration-300 ${
                index === currentIndex
                  ? "w-8 h-2 bg-[#548e9b] rounded-full"
                  : "w-2 h-2 bg-gray-300 rounded-full hover:bg-gray-400"
              }`}
            />
          ))}
        </div>

        {/* Thumbnail Strip */}
        <div className="flex justify-center space-x-4 overflow-x-auto pb-4">
          {portfolioImages.map((image, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`flex-shrink-0 relative overflow-hidden rounded-md transition-all duration-300 ${
                index === currentIndex
                  ? "ring-2 ring-[#548e9b] ring-offset-2 opacity-100"
                  : "opacity-60 hover:opacity-80"
              }`}
            >
              <img
                src={image.src}
                alt={image.title}
                className="w-20 h-14 object-cover"
              />
            </button>
          ))}
        </div>

        {/* View All Work Button */}
        <div className="text-center mt-16">
          <button   onClick={() => navigate("/portfolio")}className="group flex items-center gap-3 mx-auto bg-transparent border border-gray-300 text-gray-700 hover:border-[#548e9b] hover:text-[#548e9b] px-8 py-3 font-light tracking-wide transition-all duration-300 text-sm">
            VIEW ALL WORK
            <ArrowRight className="group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Carousel;
